import { defineComponent as _defineComponent } from 'vue'
import FeesEditor from '@/app/components/FeesAndCharges/FeesEditor.vue';
import { BModal } from 'bootstrap-vue';
import AcoTiersModal from '@/app/components/FeesAndCharges/AcoTiersModal.vue';
import { BankingScheme, FeePaymentType } from 'ah-api-gateways';
import { PropType, computed, ref } from 'vue';
import { useTheme } from 'ah-theme';
import { capitalize } from 'lodash';


export default /*#__PURE__*/_defineComponent({
  __name: 'FeesListView',
  props: {
  clientId: { type: String, required: false },
  clientName: { type: String, required: false },
  paymentType: { type: String as PropType<FeePaymentType>, required: false },
  inModal: { type: Boolean, required: false },
},
  setup(__props) {

const props = __props;



const theme = useTheme();

const feesEditor = ref<FeesEditor>();

const resetToZeromodal = ref<BModal>();

const resetToDefaultModal = ref<BModal>();

const mobileFeesEditorModal = ref<BModal>();

const isFormBusy = false;

const bankingScheme = ref<string>(BankingScheme.LOCAL);

const typeLabel = computed(() =>
  props.paymentType === FeePaymentType.PAYMENT ? capitalize(FeePaymentType.PAYMENT) : capitalize(FeePaymentType.FUNDING)
);

const partnerName = computed(() => theme.val.name);

const mobileTitle = computed(() =>
  bankingScheme.value === BankingScheme.LOCAL ? 'Edit LOCAL rail fees' : 'Edit SWIFT rail fees'
);

const isInModal = computed(() => props.inModal !== false);

function resetFeesToZero() {
  const confirm = () => {
    feesEditor.value?.setFeesToZero();
  };

  resetToZeromodal.value?.show();
  resetToZeromodal.value?.$once('ok', confirm);
  resetToZeromodal.value?.$once('hidden', () => {
    resetToZeromodal.value?.$off('ok', confirm);
  });
}

function resetFeesToDefault() {
  const confirm = () => {
    feesEditor.value?.setFeesToDefault();
  };

  resetToDefaultModal.value?.show();
  resetToDefaultModal.value?.$once('ok', confirm);
  resetToDefaultModal.value?.$once('hidden', () => {
    resetToDefaultModal.value?.$off('ok', confirm);
  });
}

function openMobileModal(bankingSchemeArg: BankingScheme) {
  bankingScheme.value = bankingSchemeArg;
  mobileFeesEditorModal.value?.show();
}

return { __sfc: true,props, theme, feesEditor, resetToZeromodal, resetToDefaultModal, mobileFeesEditorModal, isFormBusy, bankingScheme, typeLabel, partnerName, mobileTitle, isInModal, resetFeesToZero, resetFeesToDefault, openMobileModal, FeesEditor, BModal, AcoTiersModal, BankingScheme }
}

})